import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import IropsItinearyCards from './irops-itinerary-cards';
import TranslatedCopy from '../../intl/translated-copy';
import { redirectExchanges } from '../../utilities/helpers';
import { REFUND_URL } from '../../constants/urls';

function IropsDelayDelayedCards({
  allDestinationInfo,
  country,
  flightTime,
  language,
  legs,
  oldLegs,
  pnrModel,
  priorityList,
  stateStoreFront,
  tripType,
}) {
  const trip = tripType;
  const isMulticity = pnrModel?.isMulticity();
  const passengers = pnrModel?.getAllPassengers();
  const pnrValue = pnrModel?.pnrCode;
  const lastNameValue = passengers?.[0]?.lastName;
  const linkButtonExchanges = stateStoreFront?.linkBetaCC || '';
  const isPriorityList = priorityList?.data?.isPriorityList || false;
  const hasCheckin = priorityList?.data?.checkin || false;
  const params = `ckn=${hasCheckin}&pl=${isPriorityList}&utm_source=myb20&utm_medium=itinerary-button`;
  const isRoundTrip = !isMulticity && trip === 'ROUNDTRIP';
  const isOneWay = !isMulticity && trip === 'ONEWAY';
  let effectedFlights = [];

  const removedDuplicate = (array) => {
    return array?.filter((item, index) => array?.indexOf(item) === index);
  };

  const isOperativeFlight = () => {
    const {
      isChangeOag,
      isChangeOds,
      segmentStatus,
    } = legs?.[0]?.segmentsCollection?.[0];
    const affectedStatus = segmentStatus === 'SC' || segmentStatus === 'WK';
    const isChanged = isChangeOag || isChangeOds;

    if (affectedStatus && isChanged) return true;

    return false;
  };

  (oldLegs || []).map((leg, id) => {
    let flightTime = 'advanced';

    const effected = (Moment(leg?.segmentsCollection?.[0]?.departureDateTime?._i).isBefore(pnrModel?.legCollection?.[id]?.segmentsCollection?.[0]?.departureDateTime?._i));
    if (effected) {
      flightTime = 'delayed';
    }
    effectedFlights.push(flightTime);
  });
  effectedFlights = removedDuplicate(effectedFlights);


  const oldLegsData = oldLegs?.filter((oldLeg, index) =>
    Moment(oldLeg?.segmentsCollection?.[0]?.departureDateTime?._i).isBefore(pnrModel?.legCollection?.[index]?.segmentsCollection?.[0]?.departureDateTime?._i)
  );

  const newLegData = legs?.filter((delayed) =>
    delayed?.segmentsCollection?.some((segment) => segment?.flightSegmentType === 'flight-delayed')
  );
  return (
    <>
      <>
        <div className='iropsatc-conetnt-header'>
          <TranslatedCopy
            className='iropsatc-header-message'
            copyID='MYB_RESERVATION_FOUND'
            tagName='p'
          />
        </div>
        <div className='itinerary-cards-list'>
          <div className='itinerary-tag-master'>
            <div className='tag-master-container flight-delayed'>
              <TranslatedCopy 
                className='iropsatc-tag-message'
                copyID='MYB_DELAYED_W_PROTECTION'
              />
              <span className='ItineraryCard-status-hour' />
            </div>
          </div>
          { oldLegsData?.map((oldLeg, index) => {
            return (
              <IropsItinearyCards
                allDestinationInfo={ allDestinationInfo }
                country={ country }
                flightTime={ flightTime }
                isOneWay={ isOneWay }
                isRoundTrip={ isRoundTrip }
                iteration={ index + 1 }
                itineraryPartType={ oldLeg?.itineraryPartType }
                language={ language }
                legIndex={ index }
                legModel={ oldLeg }
                tripTag={ 1 }
              />
            );
          }) }
        </div>
      </>
      <>
        <div className='iropsatc-conetnt-header'>
          <TranslatedCopy
            className='iropsatc-header-message' 
            copyID='MYB_PROTECTION_FLIGHT'
            tagName='p'
          />
        </div>
        <div className='itinerary-cards-list cards-advanced'>
          <div className='itinerary-tag-master'>
            <div className='tag-master-container flight-advanced'>
              <TranslatedCopy
                className='iropsatc-tag-message'
                copyID='CC_BREADCRUMB_FLIGHTS'
              />
              <span className='ItineraryCard-status-hour' />
            </div>
          </div>
          { newLegData?.map((legModel, index) => {
            return (
              <IropsItinearyCards
                allDestinationInfo={ allDestinationInfo }
                country={ country }
                flightTime={ flightTime }
                isOneWay={ isOneWay }
                isRoundTrip={ isRoundTrip }
                iteration={ index + 1 }
                itineraryPartType={ legModel?.itineraryPartType }
                language={ language }
                legIndex={ index }
                legModel={ legModel }
                tripTag={ 1 }
              />
            );
          }) };
          { !isOperativeFlight() &&
            <div className='itinerary-refund-container'>
              <div className='refund-text-container'>
                <TranslatedCopy
                  className='itinerary-affects-text'
                  copyID='MYB_THE_CHANGE_IN_ITINERARY_AFFECTS_ALL_PASSENGERS'
                />
                <div>
                  <TranslatedCopy copyID='MYB_IF_REQUIRE_A_REFUND_REQUEST_IT' />
                  <TranslatedCopy
                    className='myb-here-text'
                    copyID='MYB_HERE'
                    onClick={ () => window.open(REFUND_URL, '_blank') }
                  />
                </div>
              </div>
              { stateStoreFront?.activeBeta &&
                <div className='itinerary-cambior-btn'
                  onClick={ () => redirectExchanges(linkButtonExchanges, lastNameValue, pnrValue, params) }
                >
                  <TranslatedCopy copyID='FO_CHANGE_FLIGHT' />
                </div>
              }
            </div>
          }
        </div>
      </>
      <div className='delay-space-container' />
    </>
  );
}

IropsDelayDelayedCards.propTypes = {
  allDestinationInfo: PropTypes.object,
  country: PropTypes.string,
  delayOnRoundTripOption: PropTypes.number,
  flightTime: PropTypes.string,
  language: PropTypes.string,
  legs: PropTypes.array,
  oldLegs: PropTypes.array,
  pnrModel: PropTypes.object,
  tripType: PropTypes.string,
};

IropsDelayDelayedCards.defaultProps = {
  allDestinationInfo: {},
  country: '',
  delayOnRoundTripOption: null,
  flightTime: '',
  language: '',
  legs: [],
  oldLegs: [],
  pnrModel: {},
  tripType: '',
};

export default IropsDelayDelayedCards;